import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import TurnedInOutlinedIcon from '@mui/icons-material/TurnedInOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import {ShoppingCartContext,UserDataContext,TotalShopCartPriceContext,ReadyToCheckout } from './Context';
import DisplayLogo from './LogoDisplay';
import { Container, Box, Typography} from '@mui/material';
import { useNotify,validateToken } from './Utils';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Badge from '@mui/material/Badge';
import { useNavigate } from 'react-router-dom';









export default function ShopCart() {
  
  const [shopCart, setShopCart] = React.useContext(ShoppingCartContext)
  const [userData] = React.useContext(UserDataContext)
  const [loading, setLoading] = React.useState(false)
  const [isReady, setIsReady] = React.useContext(ReadyToCheckout)
  const navigate = useNavigate()
  const notify = useNotify()






  const changeItemCountFromCart = async({item_id,changetype}) => {
    
    try {
      setLoading(true)
      userData.userIsLogin && await validateToken({userData})
      const fetching = await fetch(`${process.env.REACT_APP_API_URL}/addtoshopcart?item_id=${item_id}&quantity=${changetype}`,
            {
                "credentials": "include",
                "method": "PUT",
            }
        )
        if (fetching.ok) {
          const json_resp = await fetching.json()
          setShopCart(json_resp)
          return;
        }
        else {
          console.info(fetching.status)
          return;
        }
    }
    catch (error) {
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})

    }
    finally {
      setLoading(false)
    }
    
      }






  const deleteItemFromCart = async(item_id) => {
    try {
      userData.userIsLogin && await validateToken({userData})
      const fetching = await fetch(`${process.env.REACT_APP_API_URL}/addtoshopcart?item_id=${item_id}`,
            {
                "credentials": "include",
                "method": "DELETE",
            }
        )
        if (fetching.ok) {
          const json_resp = await fetching.json()
          setShopCart(json_resp)
          return;
        }
        else {
          console.info(fetching.status)
          return;
        }
    }
    catch (error) {
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})

    }
    
      }
  
   const gotoCheckout = () => {
        if (!userData.userIsLogin) {
            return navigate("/signin")
        }
        else {
            return navigate("/checkout")
        }
    }


  return (
    <Container sx={{ mt: 10 }}>
      <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
        <DisplayLogo width={{ xs: 80, md: 100 }} height={{ xs: 80, md: 100 }} />
      </Box>

      <Typography
        variant="h6"
        sx={{ textAlign: "center", mb: 2, fontSize: "1.2rem" }}
      >
        Shopping Cart
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "column",
          margin: "auto",
          p: { md: 5, xs: 1 },
          justifyItems: "center",
          width: "100%",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "10px",
          overflowX: "auto",
        }}
      >
        {shopCart?.items && shopCart.items.length > 0 ? (
          <>
            {shopCart.items.map((item, index) => (
              <List key={index} dense>
                <ListItem
                  sx={{
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "background.paper",
                  }}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => deleteItemFromCart(item.item_id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Badge
                      color="info"
                      badgeContent={item.quantity}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <TurnedInOutlinedIcon
                        fontSize="large"
                        sx={{ color: item.ribbonColorCode }}
                      />
                    </Badge>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                    <Typography>
                       {item.uploaded_file && item.textOnRibbon
                        ? "Ribbon with logo and text"
                        : item.uploaded_file
                        ? "Ribbon with logo"
                        : "Ribbon with text"}
                    </Typography>
                    }

                    secondary={
                    <Typography color='textSecondary' fontSize={11}>
                      {item.uploaded_file && item.textOnRibbon
                        ? `LOGO: ${item.uploaded_file_name}, TEXT: ${item.textOnRibbon}`
                        : item.uploaded_file
                        ? item.uploaded_file_name
                        : item.textOnRibbon}
                    </Typography>
                      
                    }
                  />

                  <ButtonGroup variant="text" sx={{ paddingX: 2 }}>
                    <Button
                      loading={loading}
                      disabled={item.quantity <= 1}
                      aria-label="reduce"
                      onClick={() =>
                        changeItemCountFromCart({
                          item_id: item.item_id,
                          changetype: "reduce_item_quantity",
                        })
                      }
                    >
                      <RemoveIcon fontSize="small" />
                    </Button>
                    <Button
                      loading={loading}
                      aria-label="increase"
                      onClick={() =>
                        changeItemCountFromCart({
                          item_id: item.item_id,
                          changetype: "increase_item_quantity",
                        })
                      }
                    >
                      <AddIcon fontSize="small" />
                    </Button>
                  </ButtonGroup>
                </ListItem>
              </List>
            ))}

            <Box
              sx={{
                display: "flex",
                width: "100%",
                paddingTop: 2,
                justifyContent: "center",
              }}
            >
              <Button
                // loading={loading}
                variant="contained"
                color="success"
                onClick={gotoCheckout}
                sx={{
                  display: shopCart.items?.length === 0 ? "none" : "",
                  width: { xs: "100%", sm: 350 },
                  height: { sm: 45, xs: 45 },
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: 12 }}>Proceed to Payment</span>
                  <span style={{ fontSize: 9 }}>
                    Total price is {shopCart?.shopcart_totalprice / 100} USD$
                  </span>
                </div>
              </Button>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
              gap: 2,
            }}
          >
            <ShoppingCartOutlinedIcon fontSize="large" />
            <Typography textAlign={"center"}>
              Shopping cart is empty!
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
}






 
